"use client";
import { useEffect, useState } from "react";
import { useAtom } from "jotai";

import SVG from "react-inlinesvg";
import Image from "next/image";
import { useParams } from "next/navigation";
import { compareAsc, format } from "date-fns";
import Link from "next/link";
import {CopyToClipboard} from 'react-copy-to-clipboard';

import NewsList from "@/components/utils/NewsList"


export default function PageComponent({post, posts }) {
  
  const params = useParams();
  const [currentUrl, set_currentUrl] = useState<string | undefined>()
  useEffect(() => {
    // console.log(post);
    set_currentUrl(window.location.href);
  },[])
  return (
    <main className="page page-news-detail">
      <div className="container-m">
        <section className="section">
          <div className="page-first-item">
            <Link className="link-back scaleHover" href="/news/">
              <div className="inner">
                <i className="icon">
                  <SVG src="/assets/img/common/icon/icon-arrow-left.svg" />
                </i>
                <span className="text">一覧へ</span>
              </div>
            </Link>
          </div>

          <div className="article-head">
            {post.title&&<h1 className="article-title bold">{post.title}</h1>}
            <div className="article-meta">
              <p className="date">{format(new Date(post.date),"yyyy.M.d")}</p>
              {post.categories && (
                <div className="categories">
                  <span className="category">
                    {post.categories.title}
                  </span>
                </div>
              )}
            </div>
          </div>

          <div className="article-body">
            <div className="article-body-content">
              {post.content && typeof post.content == "object" && post.content.map((block,i)=>{
                if(block.fieldId=="richEditor"){
                  return (
                    <div key={i} className="block richEditor" dangerouslySetInnerHTML={{__html:block.richEditor}} />
                  )
                } else if(block.fieldId=="image"){
                  return (
                    block?.image?.url && (
                      <figure key={i} className={`block size-${block.size}`}>
                        <picture className="pic round">
                          <img src={block.image.url} alt="" />
                        </picture>
                      </figure>
                    )
                  )
                }

              })}
            </div>
          </div>

          <div className="share-block pcOnly">
            <a className="share-item icon-x scaleHover" href={`https://twitter.com/intent/tweet?url=${currentUrl}&text=${post.title}%0a`} target="_blank" rel="nofollow noopener noreferrer" aria-label="Share on X (Twitter)">
              <i className="icon">
                <img src="/assets/img/common/icon/icon-x.svg" />
              </i>
            </a>
            <a className="share-item icon-facebook scaleHover" href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`} target="_blank" rel="nofollow noopener noreferrer" aria-label="Share on Facebook">
              <i className="icon">
                <img src="/assets/img/common/icon/icon-facebook.svg" />
              </i>
            </a>
            <a className="share-item icon-line scaleHover" href={`https://social-plugins.line.me/lineit/share?url=${currentUrl}&text=${post.title}`} target="_blank" rel="nofollow noopener noreferrer" aria-label="Share on Line">
              <i className="icon">
                <img src="/assets/img/common/icon/icon-line.svg" />
              </i>
            </a>
            <div className="div"></div>
            <button className="share-item button-copy scaleHover" type="button" aria-label="Share this page" onClick={ async()=>{
              try {
                await navigator.share({
                  title: document.title,
                  // text: "Learn web development on MDN!",
                  url: currentUrl,
                });
              } catch (err) {
                console.log(err);
              }
            }}>
              <i className="icon">
                <SVG src="/assets/img/common/icon/icon-share.svg" />
              </i>
              {/*
              <CopyToClipboard text={currentUrl}>
                <i className="icon"></i>
              </CopyToClipboard>
              */}
            </button>
          </div>

          <div className="share-block spOnly">
            <button className="button-link button-round scaleHover size-xs" type="button" onClick={ async()=>{
              try {
                await navigator.share({
                  title: document.title,
                  // text: "Learn web development on MDN!",
                  url: currentUrl,
                });
              } catch (err) {
                console.log(err);
              }
            }}>
              <span className="inner">
                記事を共有する
                <i className="icon">
                  <SVG src="/assets/img/common/icon/icon-share.svg" />
                </i>
              </span>
            </button>
          </div>
        </section>
      
        <section className="section section-related">
          <h2 className="section-title bold">最新記事</h2>
          <NewsList posts={posts} />
          <Link href="/news/" className="button-link button-round scaleHover size-xs">
            <span className="inner">すべてのお知らせを見る</span>
          </Link>
        </section>
      </div>
    </main>
  );
}
